import {
    ALLOCATE_SET,
    ALLOCATE_SET_SUCCESS,
    ALLOCATE_SET_FAILURE,
    RESET_ALLOCATE_SET,
} from '../actions';

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const allocateSetReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALLOCATE_SET:
            return { ...state, loading: true, error: null };
        case ALLOCATE_SET_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };
        case ALLOCATE_SET_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case RESET_ALLOCATE_SET:
            return initialState;
        default:
            return state;
    }
};

export default allocateSetReducer;
